(function() {
  const apiUrl = 'https://api.roof-bars.co.uk/api';
  const form = document.getElementById('registrationLookupForm');
  const registrationSubmitBtn = document.getElementById('registrationLookupRegSearch');
  const registrationInput = document.getElementById('registrationLookup');
  const makeModelContainer = document.getElementById('registrationLookupDetails');
  const makeModelToggle = document.getElementById('registrationLookupMakeModel');
  const makeModelSearch = document.getElementById('registrationLookupSearchBtn');
  const roofTypeContainer = document.getElementById('registrationLookupResultsRoofTypes');
  const resultsContainer = document.getElementById('registrationLookupResults');
  const resultsLink = document.getElementById('registrationLookupResultsLink');
  const errorLabel = document.getElementById('registrationErrorMessage');
  const compatibilityCheckBtns = document.querySelectorAll('.js-check-compatibility');
  const compatibilityLabel = document.getElementById('registrationLookupCompatibility');
  const modalDialog = resultsContainer ? resultsContainer.querySelector('.registration-lookup__modal-dialog') : null;
  const modalTitle = document.getElementById('registrationLookupModalHeading');
  const validationMessage = document.getElementById('registrationLookupValidationMessage');
  const modalCompatibilityContainer = document.getElementById('registrationLookupModalCompatibility');
  const modalCompatibilitySuccess = document.getElementById('registrationLookupModalCompatibilitySuccess');
  const modalCompatibilityError = document.getElementById('registrationLookupModalCompatibilityError');
  let lastFocusedElement = null;
  let isModalOpen = false;

  const dropdowns = {
    make: document.getElementById('registrationLookupMake'),
    model: document.getElementById('registrationLookupModel'),
    year: document.getElementById('registrationLookupYear'),
    roof: document.getElementById('registrationLookupRoofType')
  }

  checkCompatibility();
  getRegistration();
  setEventListeners();

  function setEventListeners() {
    // Vehicle registration form submit
    registrationSubmitBtn.addEventListener('click', (e) => submitAction(e));
    
    // Submit vehicle registration when pressing Enter key
    registrationInput.addEventListener('keydown', (e) => {
      if (e.key === "Enter") {
        submitAction(e);
      }
    })
    
    // Make and model form event listeners
    makeModelToggle.addEventListener('click', () => handleMakeModelToggle());
    dropdowns.make.addEventListener('change', () => handleDropdownChange(dropdowns.make, dropdowns.model, `${apiUrl}/lookup/${dropdowns.make.value}`, [dropdowns.model,dropdowns.year,dropdowns.roof]));
    dropdowns.model.addEventListener('change', () => handleDropdownChange(dropdowns.model, dropdowns.year, `${apiUrl}/lookup/${dropdowns.make.value}/${dropdowns.model.value}`, [dropdowns.year,dropdowns.roof]));
    dropdowns.year.addEventListener('change', () => handleDropdownChange(dropdowns.year, dropdowns.roof, `${apiUrl}/lookup/${dropdowns.make.value}/${dropdowns.model.value}/${dropdowns.year.value}`, [dropdowns.roof]));
    dropdowns.roof.addEventListener('change', (e) => handleSelectRoofType(e.target.selectedOptions[0], makeModelSearch));

    // Populate and enable resultsLink when a roof option is selected
    if (roofTypeContainer) {
      roofTypeContainer.addEventListener('click', (e) => {
        if (e.target && e.target.nodeName && e.target.nodeName.toLowerCase() === "input") {
          handleSelectRoofType(e.target, resultsLink);
        }
      });
    }

    // Continue / results button behavior
    if (resultsLink) {
      resultsLink.addEventListener('click', (e) => {
        const isDisabled = resultsLink.getAttribute('aria-disabled') === 'true';
        if (isDisabled) {
          e.preventDefault();
          showValidationMessage();
          return;
        }
        const href = resultsLink.dataset.href;
        if (href) {
          window.location.href = href;
        }
      });
    }

    // Close Modal
    if (resultsContainer && modalDialog) {
      resultsContainer.addEventListener('click', (e) => {
        const target = e.target;
        if (!(target instanceof Element)) return;
        if (target.closest('[data-registration-lookup-close]')) {
          closeResultsModal();
        }
      });
      document.addEventListener('keydown', (e) => {
        if (!isModalOpen) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          closeResultsModal();
          return;
        }
        if (e.key === 'Tab') {
          trapFocus(e);
        }
      });
    }

    // In compact mode, the submit buttons will check compatibility rather than go to the results page
    if (compatibilityCheckBtns) {
      compatibilityCheckBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (btn.getAttribute('aria-disabled') === 'true') {
            showValidationMessage();
            return;
          }
          checkCompatibility(true, btn);
          btn.disabled = true;
        })
      })
    }
  }
  
  /**
   * Gathers product results and checks if the current vehicle is compatible
   * @param {Boolean} hasFocus - Optional, set focus on compatibility message
   */
  function checkCompatibility(hasFocus, triggerBtn){ 
    if (!form.dataset.lookupCompact) {
      return;
    }
    const skus = getStorageData('lookupProductResults');
    const selectedSku = form.dataset.sku;
    if (!skus || !selectedSku) {
      return;
    }
    const isCompatible = skus.includes(selectedSku);
    const isModalTrigger = triggerBtn && resultsContainer && resultsContainer.contains(triggerBtn);

    if (isModalTrigger) {
      showModalCompatibilityMessage(isCompatible);
      form.parentNode.setAttribute('data-compatible', isCompatible ? 'true' : 'false');
      if (hasFocus) {
        form.parentNode.style.animation = 'none';
        form.parentNode.offsetHeight;
        form.parentNode.style.animation = null;
      }
      return;
    }

    hideModalCompatibilityMessage();
    form.parentNode.setAttribute('data-compatible', isCompatible ? 'true' : 'false');
    if (hasFocus) {
      compatibilityLabel.focus();
      form.parentNode.style.animation = 'none';
      form.parentNode.offsetHeight;
      form.parentNode.style.animation = null;
    }
  }

  // Check if registration data exists in local storage and print onto form
  function getRegistration() {
    const localRegistration = getStorageData('lookupRegistrationNumber');
    if (localRegistration) {
      registrationInput.value = localRegistration;
    }
  }

  // Handles opening and closing of Make/Model form
  function handleMakeModelToggle() {
    toggleActiveClass(makeModelContainer);
    resetForm();
    if (dropdowns.make.options && dropdowns.make.options.length < 2) {
      handleDropdownChange({ value: 'data' }, dropdowns.make, `${apiUrl}/lookup/`);
    }
  }

  /**
   * Generic function to handle dropdown change inside the Make/Model form
   * @param {HTMLElement} currentSelect - The active dropdown 
   * @param {HTMLElement} targetSelect - The next dropdown to populate
   * @param {string} apiEndpoint - The endpoint to fetch the data
   * @param {HTMLElement[]} reset - List of sibling dropdowns to reset
   */
  async function handleDropdownChange(currentSelect, targetSelect, apiEndpoint, reset) {
    if (!currentSelect.value) {
      return;
    }
    if (reset) {
      reset.forEach(resetDropdown);
      makeModelSearch.setAttribute('disabled', '');
    }
    targetSelect.classList.add('loading');
    try {
      const data = await fetchData(apiEndpoint);
      populateDropdown(targetSelect, data);
    } catch (error) {
      setErrorMessage(error);
    }
  }

  /**
   * Populate select element in Make/Model form - Needs to handle three
   * formats: (1) List of make/model (2) Start and end year range (3) Roof type objects
   * @param {HTMLElement} target 
   * @param {Object} data
   */
  function populateDropdown(target, data) {
    let isValid = true;
    resetDropdown(target);
    if (target.id.toLowerCase().includes('year')) {
      for (let i = parseInt(data.end_year); i >= parseInt(data.start_year); i--) {
        target.appendChild(new Option(i, i));
      }
    } else if (target.id.toLowerCase().includes('rooftype')) {
      if (data.length > 0) {        
        const formattedData = formatProductResults(data);
        Object.keys(formattedData).forEach((key) => {
          target.innerHTML += `<option data-skus="${formattedData[key].skus.join(',')}" value="${key}">${key}</option>`;
        });
      } else {
        setErrorMessage('We do not have any products available for that vehicle');
        setStorageData('lookupProductResults', '');
        setStorageData('lookupRegistrationNumber', '');
        isValid = false;
        return;
      }
      setStorageData('lookupRegistrationNumber', '');
      setStorageData('lookupProductTitle', `${dropdowns.make.value} ${dropdowns.model.value}`);
    } else {
      for (let i = 0; i <= data.length; i++) {
        if (!data[i]) {
          continue;
        }
        target.appendChild(new Option(data[i].toUpperCase(), data[i]));
      }
    }
    if (isValid) {
      target.classList.remove('loading');
      target.disabled = false;
      target.focus();
    }
  }

  /**
   * Car registration form submit
   * @param {SubmitEvent} e 
   * @returns 
   */
  async function submitAction(e) {
    e.preventDefault();
    resetForm();
    const registrationQuery = registrationInput.value.trim().toUpperCase();  
    registrationSubmitBtn.classList.add('loading');
    try {
      makeModelToggle.disabled = true;
      const data = await fetchData(`${apiUrl}/vehicle/${registrationQuery}`);
      renderCarDetails(data);
      toggleActiveClass(makeModelContainer, false);
      setStorageData('lookupRegistrationNumber', registrationQuery);
      setStorageData('lookupProductTitle', `${data.make} ${data.model}`);
    } catch (error) {
      setErrorMessage(error.message);
    } finally {
      makeModelToggle.disabled = false;
      registrationSubmitBtn.classList.remove('loading');
    }
  }

  /**
   * Display vehicle details below the form 
   * @param {Object} data 
   */
  function renderCarDetails(data) {
    toggleActiveClass(resultsContainer, true);
    openResultsModal();
    setErrorMessage();
    const infoContainer = document.getElementById('registrationLookupResultsCar');
    const carDetailsHtml = generateCarDetailsHtml(data);
    infoContainer.innerHTML = carDetailsHtml;
    renderRoofTypes(formatProductResults(data.uvcs));
  }

  /**
   * Returns markup for the car details
   * @param {Object} data 
   * @returns 
   */
  function generateCarDetailsHtml(data) {
    const vehicle = [
      data.make,
      data.model,
      data.variant
    ]
      .filter(Boolean)
      .join(' ');
  
    if (!vehicle) {
      return '';
    }
  
    return `
      <p>
      <strong>Your Vehicle:</strong>
      ${vehicle}
      </p>
    `;
  }

  /**
   * Renders roof type data onto the form
   * @param {Object} data 
   */
  function renderRoofTypes(data) {
    if (Object.keys(data).length < 1) {
      roofTypeContainer.innerHTML = '<p class="no-products">We do not have any products available for that vehicle</p>';
      setStorageData('lookupProductResults', '');
      return;
    }
    let roofTypesHtml = '';
    Object.keys(data).forEach((key, index) => {
      const optionId = `roof-type-${index}`;
      const imgSrc = data[key].image;
      const title = getRoofTypeTitle(imgSrc);
      roofTypesHtml += `<li>
        <input type="radio" id="${optionId}" name="roof-type" value="${key}" data-skus="${data[key].skus.join(',')}" />
        <img
          class="registration-lookup__roof-type-image"
          src="${imgSrc}"
          alt=""
          width="160"
          height="100"
          loading="lazy"
        />
        <label for="${optionId}">
          <span class="registration-lookup__roof-type-title">${title}</span>
        </label>
      </li>`;
    });
    roofTypeContainer.innerHTML = '<ul class="registration-lookup__roof-types-list">' + roofTypesHtml + '</ul>';
  }

  /**
   * Reformats roof type from JSON response
   * @param {Object} roofType 
   * @returns string
   */
  function getRoofTypeTitle(roofType) {
    return roofType.toString().toLowerCase().split('/').pop().split('.', 1).toString().replace(/_/g, ' ').replace('image', '');
  }

  /**
   * Empty dropdown target and disable element
   * @param {HTMLElement} target 
   */
  function resetDropdown(target) {
    target.innerHTML = '<option disabled selected value=""></option>';
    target.disabled = true;
  }

  /**
   * Removes duplicate entries in roof types array
   * @param {json} data 
   * @returns {Object} rooftypes
   */
  function formatProductResults(data) {
    const products = Array.isArray(data) ? data : [data];
    const availableRoofTypes = products.reduce((acc, { roof_type, product_sku, roof_type_image }) => {
      const title = roof_type.toString().toLowerCase();
      if (!acc[title]) {
        acc[title] = { skus: [], image: roof_type_image ?? roof_type_image };
      }
      acc[title].skus.push(product_sku);
      return acc;
    }, {});
    return availableRoofTypes;
  }

  /**
   * Returns local storage data using given string
   * @param {String} name
   */
  function getStorageData(name) {
    if (!localStorage) {
      return;
    }
    const data = localStorage.getItem(name);
    return data ? JSON.parse(data) : null;
  }

  /**
   * Sets local storage data using given string
   * @param {String} name - Storage data key
   * @param {String} data - Storage data value
   */
  function setStorageData(name, data) {
    if (!localStorage) {
      return;
    }
    localStorage.setItem(name, JSON.stringify(data));
  }


  /**
   * Toggles 'active' class on html element
   * @param {HTMLElement} element 
   * @param {Boolean} open 
   */
  function toggleActiveClass(element, force) {
    element.classList.toggle('active', force);
  }

  /**
   * Display error message
   * @param {String} string - String message to render inside error message
   */
  function setErrorMessage(string) {
    errorLabel.innerText = string ? string : '';
  }

  // Remove compatibility message and clear local storage data
  function resetForm() {
    setErrorMessage();
    form.parentNode.setAttribute('data-compatible', '');
    hideModalCompatibilityMessage();
    setStorageData('lookupRegistrationNumber', '');
    setStorageData('lookupProductResults', '');
    setStorageData('lookupProductTitle', '');
  }

  /**
   * Fetch data from the API
   * @param {string} url - The API endpoint to retrieve the data from
   * @returns json
   */
  async function fetchData(url) {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        switch (response.status) {
          case 404:
            if (!makeModelContainer.classList.contains('active')) {
              handleMakeModelToggle();
            }
            throw new Error('This Registration Has Not Been Recognised in Our System Please Select Your Vehicle Below.');
          case 429:
            throw new Error('Too many requests. Please try again later.');
          case 500:
            throw new Error('Server Error. Please try again later.');
          default:
            throw new Error('An unexpected error has occurred. Please try again later.');
        }
      }
      return response.json();
    } catch (error) {
      if (error instanceof TypeError) {
        throw new Error('Server Error. Please try again later.');
      }
      throw new Error(error.message);
    }
  }

  /**
   * Handle select dropdown change in Make/Model form
   * @param {HTMLElement} elem - Target dropdown element
   * @param {HTMLElement} targetBtn - Optional, if required disables another button in the form
   */
  function handleSelectRoofType(elem, targetBtn) {
    if (!elem.dataset.skus) {
      return;
    }
    setStorageData('lookupProductResults', elem.dataset.skus);
    hideValidationMessage();
    hideModalCompatibilityMessage();
    form.parentNode.setAttribute('data-compatible', '');
    if (targetBtn) {
      // Enter make and model form to continue if details are entered
      if (targetBtn.hasAttribute('disabled')) {
        targetBtn.removeAttribute('disabled');
      }
      if (targetBtn.hasAttribute('aria-disabled')) {
        targetBtn.setAttribute('aria-disabled', 'false');
      }
      targetBtn.disabled = false;
    }
  }

  function openResultsModal() {
    if (!resultsContainer || !modalDialog) return;
    lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : registrationSubmitBtn;
    resultsContainer.setAttribute('aria-hidden', 'false');
    isModalOpen = true;
    document.body.classList.add('registration-lookup--modal-open');
    if (modalTitle) {
      modalTitle.classList.remove('is-flashing');
    }
    hideValidationMessage();
    hideModalCompatibilityMessage();
    if (resultsLink) {
      resultsLink.disabled = false;
    }
    
    //focus to allow tab navigation for accessibility
    modalDialog.focus();
  }

  function closeResultsModal() {
    if (!resultsContainer || !modalDialog) return;
    // if modal is closed - clear the selected options and disable the continue button
    if (roofTypeContainer) {
      const selected = roofTypeContainer.querySelector('input[name="roof-type"]:checked');
      if (selected) {
        selected.checked = false;
      }
    }
    setStorageData('lookupProductResults', '');
    if (resultsLink && resultsLink.hasAttribute('aria-disabled')) {
      resultsLink.setAttribute('aria-disabled', 'true');
    }
    if (modalTitle) {
      modalTitle.classList.remove('is-flashing');
    }
    hideValidationMessage();
    hideModalCompatibilityMessage();
    toggleActiveClass(resultsContainer, false);
    resultsContainer.setAttribute('aria-hidden', 'true');
    isModalOpen = false;
    document.body.classList.remove('registration-lookup--modal-open');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function showValidationMessage() {
    if (!validationMessage) return;
    validationMessage.hidden = false;
  }

  function hideValidationMessage() {
    if (!validationMessage) return;
    validationMessage.hidden = true;
  }

  function showModalCompatibilityMessage(isCompatible) {
    if (!modalCompatibilityContainer) return;
    hideValidationMessage();
    modalCompatibilityContainer.hidden = false;
    if (modalCompatibilitySuccess) {
      modalCompatibilitySuccess.hidden = !isCompatible;
    }
    if (modalCompatibilityError) {
      modalCompatibilityError.hidden = isCompatible;
    }
  }

  function hideModalCompatibilityMessage() {
    if (modalCompatibilityContainer) {
      modalCompatibilityContainer.hidden = true;
    }
    if (modalCompatibilitySuccess) {
      modalCompatibilitySuccess.hidden = true;
    }
    if (modalCompatibilityError) {
      modalCompatibilityError.hidden = true;
    }
  }

  function trapFocus(e) {
    if (!modalDialog) return;
    const focusable = getFocusableElements(modalDialog);
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function getFocusableElements(root) {
    const selectors = [
      'a[href]',
      'area[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ];
    return Array.from(root.querySelectorAll(selectors.join(',')))
      .filter(el => el instanceof HTMLElement && !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true');
  }

}())